import { createContext, useContext } from 'react';

export const TabContext = createContext({ current: '', onChange: () => {} });

export const useTabContext = () => useContext(TabContext);
